import {UIUtilsChat} from '../../../../shared/scripts/ui_chat/UIUtilsChat'
import {UIChatPost} from '../../../../shared/scripts/ui_chat/UIChatPost'
import {AccessLevel, CHAT_MAXIMUM_CHARACTER_LIMIT, LobbyImage} from '@colonist/types'
import {setElementInnerHTML, setElementOnClick} from '../../../../shared/scripts/ui_utils/DomUtils'
import {ChatData} from '@colonist/shared-types'
import {ClientUserState} from '../../../../shared/scripts/ClientUserState'
import {isValueRequiredAccessLevel} from '@colonist/validation'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import IconSoundOn from '@static/images/icon_sound_on.svg'
import IconSoundOff from '@static/images/icon_sound_off.svg'
import {socket} from '../../../../shared/scripts/EntryShared.ts'
import {AudioManager, AudioType} from '@colonist/audio'

export class UIRoomChatController {
    readonly chatContainer: HTMLDivElement
    private readonly chatForm: HTMLFormElement
    private readonly chatInput: HTMLInputElement
    private readonly chatButton: HTMLButtonElement
    private readonly muteButton: HTMLImageElement

    constructor() {
        this.chatContainer = document.getElementById('scene_room_right_message_container') as HTMLDivElement
        this.chatForm = document.getElementById('lobby_chat_form') as HTMLFormElement
        this.chatInput = document.getElementById('lobby_chat_input') as HTMLInputElement
        this.chatButton = document.getElementById('lobby_chat_button') as HTMLButtonElement
        this.muteButton = document.getElementById('lobby_chat_mute_button') as HTMLImageElement

        this.chatForm.onsubmit = (e) => {
            e.preventDefault()
            this.sendChat()
        }

        if(!isValueRequiredAccessLevel(ClientUserState.userState?.accessLevel, AccessLevel.Moderator)) {
            this.chatInput.maxLength = CHAT_MAXIMUM_CHARACTER_LIMIT
        }

        if(UIUtilsEjsVariables.isUserOnDiscordMobile) this.chatButton.classList.add('send-chat-button-mobile')
        setElementOnClick(this.chatButton, () => {
            AudioManager.play(AudioType.Click)
            this.sendChat()
        })

        this.setSound()
    }

    private setSound() {
        setElementOnClick(this.muteButton, () => {
            AudioManager.toggleMute()
            this.muteButton.src = AudioManager.isMuted ? IconSoundOff : IconSoundOn
        })
        this.muteButton.src = AudioManager.isMuted ? IconSoundOff : IconSoundOn
    }

    clear() {
        setElementInnerHTML(this.chatContainer, {key: 'strings:colonistCommon.utils.emptyString'})
    }

    private isChatAllowed(): boolean {
        if(this.chatInput.value == '') return false
        return true
    }

    private sendChat() {
        const debugClientText = UIUtilsChat.getDebugClientText(this.chatInput.value)
        if(debugClientText != undefined) this.post({text: debugClientText, icon: LobbyImage.Admin})
        if(!this.isChatAllowed()) return
        socket.roomClient.submitChatText(this.chatInput.value)
        this.chatInput.value = ''
    }

    post(chatData: ChatData) {
        UIChatPost.post(this.chatContainer, chatData, undefined, undefined)
    }

    postMessage(message: string, senderUsername: string, senderIcon: LobbyImage) {
        const chatData: ChatData = {
            icon: senderIcon,
            text: {key: 'strings:colonistCommon.utils.#buffer', options: {value: message, interpolation: {escapeValue: false}}},
            colorAndBoldUsernames: true,
            username: senderUsername,
        }
        UIChatPost.post(this.chatContainer, chatData, undefined, undefined)
    }
}
